import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./component/header/navbar";
import HeroSection from "./component/mainSection/heroSection";
import Footer from "./component/footer/footerNew";
import AboutSection from "./component/mainSection/aboutSection";
import Offered from "./component/mainSection/offeredSection";
import Choose_us from "./component/mainSection/choose_us";
import ExploreOurMenu from "./component/mainSection/exploreOurMenu";
import OurEsteemedClients from "./component/mainSection/ourEsteemedClients";
import OurAwesomeTeam from "./component/mainSection/ourAwesomeTeam";
import AboutUs from "./component/pages/about_us/index";
import About from "./component/pages/about_us/about";
import Journey from "./component/pages/about_us/journey";
import Careers from "./component/pages/careers/careersSection";
import Culturet from "./component/pages/culture/index";
import Our_team from "./component/pages/out_team/index";
import Staffing from "./component/pages/staffing";
import Services from "./component/pages/services/index";
import Web_devlopment from "./component/pages/services/web_devlopment";
import Mobile_development from "./component/pages/services/mobile_devlopment/mobile_development";
import AIML_development from "./component/pages/services/Ml_Developmenet/aiMlDevelopmenet";
import ECommerce from "./component/pages/services/E-Commerce-development/e-Commerce";
import ManagedServices from "./component/pages/services/managedServices/managedServices";
import Portfolio from "./component/pages/portfolio/portfolio";
import Countact_us from "./component/pages/countact_us/countact_us";
import ScrollTop from "./ScrollToTop";
import CustomCursor from "./customCursor";
import StaffingSolution from "./component/pages/staffing/staffingSolution";
import Home from './component/mainSection/home';
import Testimonials from "./component/mainSection/testimonials";
import LeandingPage from "./component/header/leandingPage";
import BlogPage from "./component/footer/blogPage";
import BlogDetail from "./component/footer/blogDetail/BlogDetail";
import ITStaffingServices from './component/footer/blogDetail/ITStaffingServices'
import DelayedRecruitment from './component/footer/blogDetail/DelayedRecruitment'
import StaffingSolutions from './component/footer/blogDetail/StaffingSolutions';
import HelpYourBusiness from './component/footer/blogDetail/HelpYourBusiness'
import GlobalITStaffingSolutions from './component/footer/blogDetail/GlobalITStaffingSolutions'
import SmallToBigBusinessCompany from './component/footer/blogDetail/SmallToBigBusinessCompany'
import BusinessExcellence from './component/footer/blogDetail/BusinessExcellence'
import InternetMarketingServices from './component/footer/blogDetail/InternetMarketingServices'
import MobileAppDevelopment from './component/footer/blogDetail/MobileAppDevelopment'
import AngulerJsWebPage from './component/footer/blogDetail/AngulerJsWebPage'
import JAVAandDotNet from './component/footer/blogDetail/JAVAandDotNet '
import WordPressWebsite from './component/footer/blogDetail/WordPressWebsite'

import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return (
    <Router>
      {/* Custom Cursor visible only on desktop */}
      <div className="hidden lg:block">
        <CustomCursor />
      </div>

      {/* Header */}
      <div className="cursor-none">
        <Header />
      </div>

      {/* Routes */}
      <Routes>
        <Route
          path="/"
          element={
            <div className="cursor-none">
              <ScrollTop />

              <HeroSection />
              {/* <LeandingPage/> */}
              <Home />
              <Testimonials />
              {/* <AboutSection /> */}
              {/* <Offered />
              <Choose_us />
              <ExploreOurMenu /> */}
              {/* <OurEsteemedClients /> */}
              <OurAwesomeTeam />
            </div>
          }
        />
        <Route path="/about_us" element={<div className="cursor-none"><AboutUs /></div>} />
        <Route path="/about" element={<div className="cursor-none "><About /></div>} />
        <Route path="/tekit-journey" element={<div className="cursor-none"><Journey /></div>} />
        <Route path="/culturet" element={<div className="cursor-none"><Culturet /></div>} />
        <Route path="/careers" element={<div className="cursor-none"><Careers /></div>} />
        <Route path="/our_team" element={<div className="cursor-none"><Our_team /></div>} />
        <Route path="/staffing" element={<div className="cursor-none"><Staffing /></div>} />
        <Route path='/Staffing-Solution-Process' element={<div className="cursor-none"><StaffingSolution /></div>} />
        <Route path="/services" element={<div className="cursor-none"><Services /></div>} />
        <Route path="/web-devlopment" element={<div className="cursor-none"><Web_devlopment /></div>} />
        <Route path="/mobile-devlopment" element={<div className="cursor-none"><Mobile_development /></div>} />
        <Route path="/AI-ML-devlopment" element={<div className="cursor-none"><AIML_development /></div>} />
        <Route path="/eCommerce" element={<div className="cursor-none"><ECommerce /></div>} />
        <Route path="/managedServices" element={<div className="cursor-none"><ManagedServices /></div>} />
        <Route path="/portfolio" element={<div className="cursor-none"><Portfolio /></div>} />
        <Route path="/contact-us" element={<div className="cursor-none"><Countact_us /></div>} />
        <Route path="/blogPage" element={<div className="cursor-none"><BlogPage /></div>} />
        <Route path="/blogDetail" element={<div className="cursor-none"><BlogDetail /></div>} />
        <Route path="/ITStaffingServices" element={<div className="cursor-none"><ITStaffingServices /></div>} />
        <Route path="/delayedRecruitment" element={<div className="cursor-none"><DelayedRecruitment /></div>} />
        <Route path="/staffingSolutions" element={<div className="cursor-none"><StaffingSolutions /></div>} />
        <Route path="/helpYourBusiness" element={<div className="cursor-none"><HelpYourBusiness /></div>} />
        <Route path="/globalITStaffingSolutions" element={<div className="cursor-none"><GlobalITStaffingSolutions /></div>} />
        <Route path="/smallToBigBusinessCompany" element={<div className="cursor-none"><SmallToBigBusinessCompany /></div>} />
        <Route path="/businessExcellence" element={<div className="cursor-none"><BusinessExcellence /></div>} />
        <Route path="/internetMarketingServices" element={<div className="cursor-none"><InternetMarketingServices /></div>} />
        <Route path="/mobileAppDevelopment" element={<div className="cursor-none"><MobileAppDevelopment /></div>} />
        <Route path="/angulerJsWebPage" element={<div className="cursor-none"><AngulerJsWebPage /></div>} />
        <Route path="/JAVAandDotNet" element={<div className="cursor-none"><JAVAandDotNet /></div>} />
        <Route path="/WordPressWebsite" element={<div className="cursor-none"><WordPressWebsite /></div>} />
      </Routes>

      {/* Footer */}
      <div className="cursor-none">
        <Footer />
      </div>
    </Router>
  );
}

export default App;
